import { isAllowOrderTypeInCountry } from 'features/common/helpers';
import { CountryCodeEnum, OrderTypeEnum, RolesEnum } from 'features/common/types';

export const canUseDLocalCapture = (
	pendingAuthorization: number,
	countryCode: CountryCodeEnum,
	role?: RolesEnum,
): boolean => {
	if (pendingAuthorization <= 0) return false;
	if (!isAllowOrderTypeInCountry(OrderTypeEnum.DLOCAL, countryCode)) return false;

	return role === RolesEnum.SUPERADMIN || role === RolesEnum.ADMIN || role === RolesEnum.OPERATOR;
};
